import React, { Component } from "react";
import { HashRouter, Route, Switch } from "react-router-dom";
import Loadable from "react-loadable";
import "./App.scss";
import ForgetPassword from "./pages/ForgetPassword/ForgetPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import BlockedUser from "./pages/BlockedUser/BlockedUser";
// Sync import: react-loadable ile DefaultLayout "Loading..."da sonsuza takılıyordu
import DefaultLayout from "./containers/DefaultLayout";

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);
// Pages
const SelectProject = Loadable({
  loader: () => import("./pages/SelectProject"),
  loading,
});

const Login = Loadable({
  loader: () => import("./pages/Login"),
  loading,
});
const PayByLink = Loadable({
  loader: () => import("./pages/PayByLink/PayByLink"),
  loading,
});

const MerchantWidget = Loadable({
  loader: () => import("./pages/MerchantWidget/MerchantWidget"),
  loading,
});

const PaymentResult = Loadable({
  loader: () => import("./pages/MerchantWidget/PaymentResult"),
  loading,
});

const PayLinkQRBuffer = Loadable({
  loader: () => import("./pages/PayByLink/PayLinkQRBuffer"),
  loading,
});

const PayByConstantLink = Loadable({
  loader: () => import("./pages/PayByConstantLink/PayByConstantLink"),
  loading,
});

const Page404 = Loadable({
  loader: () => import("./views/Pages/Page404"),
  loading,
});

const Page500 = Loadable({
  loader: () => import("./views/Pages/Page500"),
  loading,
});

const PaymentPage = Loadable({
  loader: () => import("./pages/PaymentPage/PaymentPage"),
  loading,
});

const PaymentIframe = Loadable({
  loader: () => import("./pages/PaymentIframe/PaymentIframe"),
  loading,
});

const PaymentReceipt = Loadable({
  loader: () => import("./pages/PaymentReceipt/PaymentReceipt"),
  loading,
});

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Switch>
          <Route exact path="/login" name="Login Page" component={Login} />
          <Route exact path="/404" name="Page 404" component={Page404} />
          <Route exact path="/500" name="Page 500" component={Page500} />
          <Route
            exact
            path="/payment-page/:token"
            name="Ödeme Ekranı"
            component={PaymentPage}
          />
          <Route
            exact
            path="/payment-iframe/:id"
            name="Ödeme Ekranı"
            component={PaymentIframe}
          />
          <Route
            exact
            path="/payment-receipt/:id"
            name="Dekont Ekranı"
            component={PaymentReceipt}
          />
          <Route
            exact
            path="/selectProject"
            name="Projeler"
            component={SelectProject}
          />

          <Route
            exact
            path="/pay-by-link/:guid"
            name="Pay By Link"
            component={PayByLink}
          />

          <Route
            exact
            path="/pay-by-link-buffer/:guid"
            name="Pay By Link"
            component={PayLinkQRBuffer}
          />

          <Route
            exact
            path="/pay-by-constant-link/:guid"
            name="Pay By Constant Link"
            component={PayByConstantLink}
          />

          <Route
            exact
            path="/payment/:merchantName/:partnerId"
            name="Merchant's Widget Page"
            component={MerchantWidget}
          />
          <Route
            exact
            path="/payment-result/:trxId"
            name="Payment Result Page"
            component={PaymentResult}
          />
          <Route
            exact
            path="/forgot-password"
            name="Forgot Password"
            component={ForgetPassword}
          />
          <Route
            exact
            path="/reset-password"
            name="Reset Password"
            component={ResetPassword}
          />
          <Route
            exact
            path="/blocked-user"
            name="Blocked User"
            component={BlockedUser}
          />

          <Route path="/" name="Ana Sayfa" component={DefaultLayout} />
        </Switch>
      </HashRouter>
    );
  }
}

export default App;
